import InputMeter from './input-meter2.vue';
export default InputMeter;
